import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/questionTopic/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/questionTopic/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/questionTopic/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/questionTopic/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/questionTopic/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/questionTopic/delete',
      method: 'delete',
      params: data
    })
  }
}
